module.exports = __webpack_public_path__ + "img/so-do-man-hinh.01d8390e.png";